//
// Writable application context
//

import type { TMakePaddleController } from "../srv/PaddleController"
import { HttpApiError, HttpApiMiddleware } from "@effect/platform"
import { NotFoundError } from "@open-revenue/schema/api-models"
import { Context, Effect } from "effect"

export class PaddleControllerService extends Context.Tag(
  "@open-revenue/paddle/storage/PaddleController"
)<PaddleControllerService, Effect.Effect.Success<TMakePaddleController>>() {}

export class PaddleControllerMiddleware extends HttpApiMiddleware.Tag<PaddleControllerMiddleware>()(
  "@open-revenue/paddle/PaddleController",
  {
    // Define the error schema for unauthorized access
    failure: NotFoundError,
    // Specify the resource this middleware will provide
    provides: PaddleControllerService,
  }
) {}
